import React from 'react';
import Input from "components/form/Input";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import GModal from "components/ui/modal/Modal";
import GButton from "components/ui/button/Button";
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getkitchenFlowFilteredData } from '../../services/kitchenFlowService';

export default function FilterModal({onClose , data }) {
    const { t } = useTranslation();
    const dispatch =useDispatch();

    const [filteredData, setFilteredData] = useState(data);

    // Filter Data
    const [filterCriteria, setFilterCriteria] = useState({
        KitchenFlowsName: ""      
      });

      const handleFilterReservation = (e) => {
        e.preventDefault();
    
        const filteredResult = data.filter((item) => {
          const { KitchenFlowsName } = filterCriteria;
    
          let filterKitchenFlowsName = true;
    
          if (KitchenFlowsName) {
            filterKitchenFlowsName = item.KitchenFlowsName.toLowerCase().includes(KitchenFlowsName.toLowerCase());
          }
    
          return (
            filterKitchenFlowsName 
          );

        });
    
        setFilteredData(filteredResult);
        onClose();
        dispatch(getkitchenFlowFilteredData(filteredResult));
      };

  return <>
  
  <GModal
      onClose={onClose}
      modalHeader={t("pages.cost_adjustment.cost_adjustment_filter")}
      modalContent={
        <Box p={4}>
          <form 
            onSubmit={handleFilterReservation}
          >
            <Stack spacing={6}>
                  <Input
                    label={t("pages.kitchenFlow.name")}
                    labelStyle={{ textTransform: "capitalize" }}
                    placeholder={t("pages.kitchenFlow.name")}
                    name="KitchenFlowsName"
                    value={filterCriteria.KitchenFlowsName}
                    onChange={(e) =>
                      setFilterCriteria({
                        ...filterCriteria,
                        KitchenFlowsName: e.target.value,
                      })
                    }
                  />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  
  </>
};
